goog.provide("shadow.js.shim.module$date_fns$set$default");
shadow.js.shim.module$date_fns$set$default = shadow.js.require(200, {})["default"];
